import { render, staticRenderFns } from "./ForumCategoryForm.vue?vue&type=template&id=285e9f6a&scoped=true"
import script from "./ForumCategoryForm.vue?vue&type=script&lang=js"
export * from "./ForumCategoryForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "285e9f6a",
  null
  
)

export default component.exports